import type { GetContractResponse } from '@vy/api-definition';
import { GetContractResponseSchema } from '@vy/api-definition';
import { validateNotNullOrUndefined } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useContract(contractId: string, options?: CustomUseQueryOptions<GetContractResponse>) {
  const getContractQuery = useQuery(
    queryKeys.contracts(contractId),
    async () => {
      const api = getPrivateApi();
      const getContractResponse = await api.getContract({ contractId });

      return GetContractResponseSchema.parse(getContractResponse);
    },
    {
      suspense: true,
      ...options,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchInterval: false,
    },
  );

  validateNotNullOrUndefined(getContractQuery.data, 'Contract not found');

  return getContractQuery;
}
